import React, { useState } from "react";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import BaseLayout from "../../layout/BaseLayout";
import Snackbar from "@mui/material/Snackbar";
import Pagination from "@mui/material/Pagination";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ReactDatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";

const CanalPaiement = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 7,
    nombrePage: 1,
  });
  const [startDate, setStartDate] = useState(new Date());
  const [loadingData, setLoadingData] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center",
  });
  const [searchLoading, setSearchLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [desactiveLoading, setDesactiveLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [autreCanalListe, setautreCanalListe] = useState([]);
  const [autreCanalInfo, setNiveauInfo] = useState(null);
  const [serviceData, setNiveauData] = useState({
    id: "",
    nom: "",
    code: "",
  });

  const { vertical, horizontal } = snackbarPosition;

  const searchAutreCanal = () => {};

  const modalDesactive = (niveau) => {
    setNiveauInfo(niveau);
    document.getElementById("desactive-warning").click();
  };

  const modalCreateAutreCanal = () => {
    setNiveauInfo(null);
    setNiveauData({
      id: "",
      nom: "",
      code: "",
    });
  };

  const modalEditAutreCanal = (niveau) => {
    document.getElementById("ajout-autre-canal").click();
    setNiveauInfo(niveau);
    setNiveauData({
      id: niveau.id,
      nom: niveau.nom,
    });
  };

  const ajoutAutreCanal = () => {};

  const supprimerAutreCanal = () => {};

  const changerEtatNiveau = () => {};

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value,
    }));
    if (searchTerm.length !== 0) {
      // getListeUtilisateur(value - 1, pageQuery.size)
      //   .then((res) => {
      //     setUserListe(res.data.donnee.utilisateurs);
      //     setPageQuery((prev) => ({
      //       ...prev,
      //       nombrePage: res.data.donnee.totalPages,
      //     }));
      //     setLoadingData(false);
      //   })
      //   .catch((err) => {
      //     setLoadingData(false);
      //     console.log("api error", err);
      //   });
    } else {
      // getListeUtilisateur(value - 1, pageQuery.size, searchTerm)
      //   .then((res) => {
      //     setUserListe(res.data.donnee.utilisateurs);
      //     setPageQuery((prev) => ({
      //       ...prev,
      //       nombrePage: res.data.donnee.totalPages,
      //     }));
      //     setLoadingData(false);
      //   })
      //   .catch((err) => {
      //     setLoadingData(false);
      //     console.log("api error", err);
      //   });
    }
  };

  const TableElement = ({ autreCanal }) => {
    return (
      <tr>
        <td className="px-4">{autreCanal.nom}</td>
        <td className="w-40 px-4">
          <div className="flex items-center gap-x-3">
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => {
                document.getElementById("delete-warning").click();
                setNiveauInfo(autreCanal);
              }}
            >
              <DeleteIcon />
            </button>
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => modalEditAutreCanal(autreCanal)}
            >
              <EditIcon />
            </button>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <BaseLayout>
      <div className="w-10/12 mx-auto pt-32">
        <h1 className="text-2xl text-black font-bold">
          Autre canal de paiement
        </h1>
        <div className="mt-10">
          <div className="mb-5 flex items-center justify-between">
            <div>
              <p>Rechercher</p>
              <div className="flex items-center gap-x-2">
                <input
                  type="text"
                  disabled={searchLoading}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Rechercher un élément"
                  className="input input-bordered w-full max-w-xs"
                />
                <button
                  disabled={searchLoading}
                  className="w-14 h-11 bg-stone-900 text-white rounded-md flex items-center justify-center"
                  onClick={searchAutreCanal}
                >
                  {!searchLoading ? (
                    <SearchIcon />
                  ) : (
                    <TailSpin
                      height="25"
                      width="25"
                      color="#fff"
                      ariaLabel="tail-spin-loading"
                      radius="1"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={searchLoading}
                    />
                  )}
                </button>
              </div>
            </div>
            <label
              htmlFor="ajout-autre-canal"
              className="bg-momo-blue text-white px-3 py-2 rounded-lg font-medium cursor-pointer"
              onClick={modalCreateAutreCanal}
            >
              Ajouter un paiement
            </label>
          </div>
          <div className="overflow-x-auto">
            <table className="table table-compact w-full mb-2">
              <thead>
                <tr>
                  <th className="capitalize py-4 px-4">Elève</th>
                  <th className="capitalize py-4 px-4">Service</th>
                  <th className="capitalize py-4 px-4">Montant</th>
                  <th className="capitalize py-4 px-4">Date de paiement</th>
                  <th className="capitalize py-4 px-4">Canal</th>
                  <th className="capitalize py-4 px-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {!loadingData && autreCanalListe.length > 0 ? (
                  autreCanalListe.map((item) => (
                    <TableElement key={item.id} autreCanal={item} />
                  ))
                ) : !loadingData && autreCanalListe.length === 0 ? (
                  <tr>
                    <td colSpan="6">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <ErrorOutlineIcon />
                        <p className="font-medium text-red-500">
                          Aucun élément trouvé
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : loadingData && autreCanalListe.length === 0 ? (
                  <tr>
                    <td colSpan="6">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="flex justify-end">
              <Pagination
                count={pageQuery.nombrePage}
                page={pageQuery.pagePagination}
                variant="outlined"
                shape="rounded"
                onChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* MODAL AJOUT AUTRE CANAL */}
      <input type="checkbox" id="ajout-autre-canal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">
            {autreCanalInfo === null
              ? "Ajouter un paiement via un canal"
              : "Modifier ce canal"}
          </h3>
          <div className="py-5">
            <div className="flex items-center gap-x-4">
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Choix du service</span>
                </label>
                <select className="select select-bordered w-full font-normal">
                  <option disabled selected>
                    Choisir un service
                  </option>
                  <option>Scolarité</option>
                  <option>Cantine</option>
                  <option>Transport</option>
                </select>
              </div>
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Canal de paiement</span>
                </label>
                <select className="select select-bordered w-full font-normal">
                  <option disabled selected>
                    Choisir un canal
                  </option>
                  <option>Orange Money</option>
                  <option>Moov Money</option>
                  <option>Wave</option>
                  <option>Cash</option>
                </select>
              </div>
            </div>
            <div>
              <label className="label">
                <span className="label-text">Niveau d'étude</span>
              </label>
              <select className="select select-bordered w-full font-normal">
                <option disabled selected>
                  Choisir un niveau
                </option>
                <option>6 ème</option>
                <option>5 ème</option>
                <option>4 ème</option>
                <option>2nd</option>
              </select>
            </div>
            <div>
              <label className="label">
                <span className="label-text">Elève</span>
              </label>
              <select className="select select-bordered w-full font-normal">
                <option disabled selected>
                  Choisir un élève
                </option>
                <option>Tanoh</option>
                <option>Koné</option>
                <option>ZADI</option>
              </select>
            </div>
            <div>
              <label className="label">
                <span className="label-text">Montant payé (FCFA)</span>
              </label>
              <input
                disabled={addLoading}
                type="text"
                // value={tarifData.code}
                // onChange={(e) =>
                //   setTarifData((prevState) => ({
                //     ...prevState,
                //     code: e.target.value,
                //   }))
                // }
                placeholder="3214"
                className="input input-bordered w-full"
              />
            </div>
            <div>
              <label className="label">
                <span className="label-text">Date de paiement</span>
              </label>
              <div className="form-datapicker w-full">
                <ReactDatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="dd/MM/yyyy"
                  className="z-50 w-full px-3 py-2.5 rounded-lg border border-gray-300"
                />
              </div>
            </div>
          </div>
          <div className="modal-action">
            {!addLoading ? (
              <label
                htmlFor="ajout-autre-canal"
                className="bg-black text-white font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="ajout-autre-canal"
                className="bg-black text-white font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={addLoading}
              className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md"
              onClick={ajoutAutreCanal}
            >
              {!addLoading ? (
                <span>{!autreCanalInfo ? "Enregistrer" : "Modifier"}</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={addLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SUPPRIMER AUTRE CANAL */}
      <input type="checkbox" id="delete-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-2xl text-center text-red-500">
            Attention !
          </h3>
          <p className="text-lg text-center py-4">
            Cette action est irréversible
          </p>
          <div className="modal-action flex justify-center gap-x-5">
            {!deleteLoading ? (
              <label
                id="delete-warning-btn"
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={deleteLoading}
              className="bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              onClick={supprimerAutreCanal}
            >
              {!deleteLoading ? (
                <span>Supprimer</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={deleteLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* DESACTIVER AUTRE CANAL */}
      <input type="checkbox" id="desactive-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3
            className={
              autreCanalInfo && autreCanalInfo.enabled
                ? "font-bold text-2xl text-center text-red-500"
                : "font-bold text-2xl text-center text-green-500"
            }
          >
            {autreCanalInfo && autreCanalInfo.enabled
              ? "Désactiver ce niveau d'étude"
              : "Activer ce niveau d'étude"}
          </h3>
          <div className="modal-action flex justify-center gap-x-5">
            {!desactiveLoading ? (
              <label
                id="desactive-warning-btn"
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={desactiveLoading}
              className={
                autreCanalInfo && autreCanalInfo.enabled
                  ? "bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
                  : "bg-green-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              }
              onClick={changerEtatNiveau}
            >
              {!desactiveLoading ? (
                <>
                  {autreCanalInfo && autreCanalInfo.enabled ? (
                    <span>Désactiver</span>
                  ) : (
                    <span>Activer</span>
                  )}
                </>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={desactiveLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
        >
          <div className="bg-green-500 text-white px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
        >
          <div className="bg-red-500 text-white px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </BaseLayout>
  );
};

export default CanalPaiement;
